import { render, staticRenderFns } from "./RedeCredenciadaEmpty.vue?vue&type=template&id=5516be03&scoped=true"
import script from "./RedeCredenciadaEmpty.vue?vue&type=script&lang=js"
export * from "./RedeCredenciadaEmpty.vue?vue&type=script&lang=js"
import style0 from "./RedeCredenciadaEmpty.vue?vue&type=style&index=0&id=5516be03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516be03",
  null
  
)

export default component.exports